import { fabric } from 'fabric';

import { BLUE, WHITE, GREY } from '../ItemColors';

const drawPlayer = (item, iconFill, innerFill, iconSize, label) => {
  let group;

  fabric.loadSVGFromString(item.svg, (objects, options) => {
    const canvasItem = fabric.util.groupSVGElements(objects, options);
    canvasItem.set({
      originX: 'center',
      originY: 'center',
    });
    canvasItem.scaleToHeight(item.sizes[iconSize].height);
    canvasItem.scaleToWidth(item.sizes[iconSize].width);
    canvasItem._objects[0].set({ fill: innerFill });

    // Because the USSF player always has a black tip, we need to only fill the first path of the SVG
    if (item.type === 'ussf_triangle_player' || item.type === 'ussf_circle_player') {
      canvasItem._objects[0].set({ fill: iconFill });
    } else {
      canvasItem._objects[1].set({ fill: iconFill });
    }

    const playerText = new fabric.Text(label, {
      fontSize: 9,
      fontFamily: 'euclid-flex',
      fontWeight: 500,
      originX: 'center',
      originY: 'center',
    });

    if (item.type === 'ussf_triangle_player' || item.type === 'ussf_circle_player') {
      if (iconFill === WHITE || iconFill === GREY) {
        playerText.set({ fill: BLUE });
      } else {
        playerText.set({ fill: WHITE, shadow: 'rgba(0,0,0,0.5) 0px 1px 1px' });
      }
    }

    group = new fabric.Group([canvasItem, playerText], {
      customProps: item,
      padding: 2,
      rotateAngle: 0,
      playerText: item.text,
    });

    group.toObject = function() {
      return fabric.util.object.extend(this.callSuper('toObject'), {
        customProps: item,
        iconFill,
        rotateAngle: this.rotateAngle,
        playerText: playerText.text,
      });
    };
  });

  return new Promise((resolve) => {
    if (group) {
      resolve(group);
    }
  });
};

export default drawPlayer;



// WEBPACK FOOTER //
// ./library/app/components/Diagram/Items/Player.js